import axios from 'axios'
import config from 'src/config'

export function getPublicExpressBaseUrl() {
  const url = String(config.apiGateway.EXPRESS_URL || 'http://localhost:8000')
  return url.replace(/\/api\/v1\/?$/, '')
}

export function createPublicExpressClient({ timeout } = {}) {
  return axios.create({
    baseURL: getPublicExpressBaseUrl(),
    timeout: timeout || 120000,
  })
}

export async function publicExpressPost(path, body, options = {}) {
  const client = createPublicExpressClient({
    timeout: options.timeout,
  })
  const response = await client.post(path, body)
  return response.data
}
